import Layout from "@/views/layout/layout";
import Child from "@/views/layout/child";
const rootPath = "/adm";

const admin = {
  path: rootPath,
  name: "admin",
  description: "뱅킹관리",
  redirect: rootPath + "/userGuideMotp",
  component: Layout,
  children: [
    {
      path: "approval",
      name: "approval",
      description: "결재",
      redirect: { name: "underList" },
      component: () => import("@/views/templates/admin/approvalParent"),
      children: [
        {
          path: "",
          name: "underList",
          description: "결재진행내역",
          component: () => import("@/views/templates/admin/underApproval"),
          meta: {
            roles: ["login", "corp"],
            step: 1,
          },
        },
        {
          path: "",
          name: "standingDetail",
          description: "결재상세",
          component: () => import("@/views/templates/admin/aprvalDtl"),
          meta: {
            roles: ["login", "corp"],
            step: 2,
          },
        },
        {
          path: "historyList",
          name: "historyList",
          description: "결재완료내역",
          component: () => import("@/views/templates/admin/historyApproval"),
          meta: {
            roles: ["login", "corp"],
            step1: 1,
          },
        },
        {
          path: "approvalComplete",
          name: "approvalComplete",
          description: "상신완료",
          component: () => import("@/views/templates/admin/approvalComplete"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
        {
          path: "",
          name: "aprvalProc",
          description: "결재승인완료",
          component: () => import("@/views/templates/admin/aprvalProc"),
          meta: {
            roles: ["login", "corp"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "personalInfo",
      name: "personalInfo",
      description: "고객정보관리",
      component: () => import("@/views/templates/admin/personalInfoParent"),
      redirect: { name: "perInfoAuthentication" },
      children: [
        {
          path: "authentication",
          name: "perInfoAuthentication",
          description: "고객정보조회/수정-인증",
          component: () => import("@/views/templates/admin/userPasswordAuthentication"),
          meta: {
            roles: ["login", "ppsn"],
            step: 1,
          },
        },
        {
          path: "",
          name: "perInfo",
          description: "고객정보조회/수정-조회",
          component: () => import("@/views/templates/admin/personalInfoWrapper0"),
          meta: {
            roles: ["login", "ppsn"],
            step: 2,
          },
        },
        {
          path: "01",
          name: "perInfoStep1",
          description: "고객정보조회/수정-수정",
          component: () => import("@/views/templates/admin/personalInfoWrapper1"),
          meta: {
            roles: ["login", "ppsn"],
            step: 3,
          },
        },
        {
          path: "02",
          name: "perInfoStep2",
          description: "고객정보조회/수정-확인",
          component: () => import("@/views/templates/admin/personalInfoWrapper2"),
          meta: {
            roles: ["login", "ppsn"],
            step: 4,
          },
        },
        {
          path: "03",
          name: "perInfoStep3",
          description: "고객정보조회/수정-완료",
          component: () => import("@/views/templates/admin/personalInfoComplete"),
          meta: {
            roles: ["login", "ppsn"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "acno",
      description: "계좌관리-개인",
      component: () => import("@/views/templates/admin/manageForPpsn"),
      children: [
        {
          path: "manageAccounts",
          description: "출금계좌등록/삭제",
          redirect: { name: "manageAccountsList" },
          component: () => import("@/views/templates/admin/manageAccounts"),
          children: [
            {
              path: "list",
              name: "manageAccountsList",
              description: "출금 계좌",
              component: () => import("@/views/templates/admin/manageAccountsList"),
              meta: {
                roles: ["login", "ppsn"],
                step: 1,
              },
            },
            {
              path: "register",
              name: "manageAccountsRegister",
              description: "등록",
              component: () => import("@/views/templates/admin/manageAccountsRegister"),
              meta: {
                roles: ["login", "ppsn"],
                step: 2,
              },
            },
            {
              path: "registerFin",
              name: "manageAccountsRegisterFin",
              description: "등록완료",
              component: () => import("@/views/templates/admin/manageAccountsRegisterFin"),
              meta: {
                roles: ["login", "ppsn"],
                isLast: true,
              },
            },
            {
              path: "delete",
              name: "manageAccountsDelete",
              description: "삭제",
              component: () => import("@/views/templates/admin/manageAccountsDelete"),
              meta: {
                roles: ["login", "ppsn"],
                step: 2,
              },
            },
            {
              path: "deleteFin",
              name: "manageAccountsDeleteFin",
              description: "삭제완료",
              component: () => import("@/views/templates/admin/manageAccountsDeleteFin"),
              meta: {
                roles: ["login", "ppsn"],
                isLast: true,
              },
            },
          ],
        },
        {
          path: "managePayees",
          description: "자주쓰는계좌등록/삭제",
          redirect: { name: "managePayeesList" },
          component: Child,
          children: [
            {
              path: "list",
              name: "managePayeesList",
              description: "목록",
              component: () => import("@/views/templates/admin/managePayeesList"),
              meta: {
                roles: ["login", "ppsn"],
                step: 1,
              },
            },
            {
              path: "register",
              name: "managePayeesRegister",
              description: "등록",
              component: () => import("@/views/templates/admin/managePayeesRegister"),
              meta: {
                roles: ["login", "ppsn"],
                step: 2,
              },
            },
            {
              path: "obRegister",
              name: "managePayeesObRegister",
              description: "등록",
              component: () => import("@/views/templates/admin/managePayeesObRegister"),
              meta: {
                roles: ["login", "ppsn"],
              },
            },
            {
              path: "cardRegister",
              name: "managePayeesCardRegister",
              description: "등록",
              component: () => import("@/views/templates/admin/manageCardRegister"),
              meta: {
                roles: ["login", "ppsn"],
              },
            }
          ],
        },
        {
          path: "acnPwdUptReq",
          description: "계좌비밀번호 변경",
          redirect: { name: "acnPwdUptReqStep1" },
          component: () => import("@/views/templates/admin/acnPwdUptReq"),
          children: [
            {
              path: "step1",
              name: "acnPwdUptReqStep1",
              description: "목록",
              component: () => import("@/views/templates/admin/acnPwdUptReqStep1"),
              meta: {
                transparent: true,
                roles: ["login", "ppsn"],
                step: 1,
              },
            },
            {
              path: "step2",
              name: "acnPwdUptReqStep2",
              description: "등록",
              component: () => import("@/views/templates/admin/acnPwdUptReqStep2"),
              meta: {
                transparent: true,
                roles: ["login", "ppsn"],
                step: 2,
              },
            },
            {
              path: "step3",
              name: "acnPwdUptReqStep3",
              description: "완료",
              component: () => import("@/views/templates/admin/acnPwdUptReqStep3"),
              meta: {
                transparent: true,
                roles: ["login", "ppsn"],
                isLast: true,
              },
            },
          ],
        },
        {
          path: "transferLimitParent",
          name: "transferLimitParent",
          description: "이체한도 조회/감액",
          redirect: { name: "transferLimit" },
          component: () => import("@/views/templates/admin/transferLimitParent"),
          children: [
            {
              path: "transferLimit",
              name: "transferLimit",
              description: "이체한도 조회",
              component: () => import("@/views/templates/admin/transferLimit"),
              meta: {
                roles: ["login", "ppsn"],
              },
            },
            {
              path: "transferLimitDecrement",
              name: "transferLimitDecrement",
              description: "이체한도 감액",
              component: () => import("@/views/templates/admin/transferLimitDecrement"),
              meta: {
                roles: ["login", "ppsn"],
              },
            },
            {
              path: "transferLimitComplete",
              name: "transferLimitComplete",
              description: "이체한도 수정 완료",
              component: () => import("@/views/templates/admin/transferLimitComplete"),
              meta: {
                transparent: true,
                roles: ["login", "ppsn"],
              },
            },
          ],
        },
      ],
    },
    {
      path: "personalInfoCorp",
      name: "personalInfoCorp",
      description: "고객정보관리-기업",
      component: () => import("@/views/templates/admin/personalInfoParent"),
      redirect: { name: "perInfoAuthenticationCorp" },
      children: [
        {
          path: "authentication",
          name: "perInfoAuthenticationCorp",
          description: "고객정보조회/수정-인증",
          component: () => import("@/views/templates/admin/userPasswordAuthentication"),
          meta: {
            roles: ["login", "corp"],
            step: 1,
          },
        },
        {
          path: "",
          name: "perInfoCorp",
          description: "고객정보조회/수정-조회",
          component: () => import("@/views/templates/admin/personalInfoWrapper0"),
          meta: {
            roles: ["login", "corp"],
            step: 2,
          },
        },
        {
          path: "01",
          name: "perInfoStep1Corp",
          description: "고객정보조회/수정-수정",
          component: () => import("@/views/templates/admin/personalInfoWrapper1"),
          meta: {
            roles: ["login", "corp", "master"],
            step: 3,
          },
        },
        {
          path: "02",
          name: "perInfoStep2Corp",
          description: "고객정보조회/수정-확인",
          component: () => import("@/views/templates/admin/personalInfoWrapper2"),
          meta: {
            roles: ["login", "corp", "master"],
            step: 4,
          },
        },
        {
          path: "03",
          name: "perInfoStep3Corp",
          description: "고객정보조회/수정-완료",
          component: () => import("@/views/templates/admin/personalInfoComplete"),
          meta: {
            roles: ["login", "corp", "master"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "acnoForCorp",
      description: "계좌관리-기업",
      component: Child,
      redirect: { name: "manageAccountsListForCorp" },
      children: [
        {
          path: "manageAccounts",
          description: "출금계좌등록/삭제",
          redirect: { name: "manageAccountsListForCorp" },
          component: () => import("@/views/templates/admin/manageAccounts"),
          children: [
            {
              path: "list",
              name: "manageAccountsListForCorp",
              description: "목록",
              component: () => import("@/views/templates/admin/manageAccountsList"),
              meta: {
                roles: ["login", "corp"],
                step: 1,
              },
            },
            {
              path: "register",
              name: "manageAccountsRegisterForCorp",
              description: "등록",
              component: () => import("@/views/templates/admin/manageAccountsRegister"),
              meta: {
                roles: ["login", "corp"],
                step: 2,
              },
            },
            {
              path: "registerFin",
              name: "manageAccountsRegisterFinForCorp",
              description: "등록완료",
              component: () => import("@/views/templates/admin/manageAccountsRegisterFin"),
              meta: {
                roles: ["login", "corp"],
                isLast: true,
              },
            },
            {
              path: "delete",
              name: "manageAccountsDeleteForCorp",
              description: "삭제",
              component: () => import("@/views/templates/admin/manageAccountsDelete"),
              meta: {
                roles: ["login", "corp"],
                step: 2,
              },
            },
            {
              path: "deleteFin",
              name: "manageAccountsDeleteFinForCorp",
              description: "삭제완료",
              component: () => import("@/views/templates/admin/manageAccountsDeleteFin"),
              meta: {
                roles: ["login", "corp"],
                isLast: true,
              },
            },
          ],
        },
        {
          path: "managePayees",
          description: "자주쓰는계좌등록/삭제",
          redirect: { name: "managePayeesListForCorp" },
          component: Child,
          children: [
            {
              path: "list",
              name: "managePayeesListForCorp",
              description: "목록",
              component: () => import("@/views/templates/admin/managePayeesList"),
              meta: {
                roles: ["login", "corp"],
                step: 1,
              },
            },
            {
              path: "register",
              name: "managePayeesRegisterForCorp",
              description: "등록",
              component: () => import("@/views/templates/admin/managePayeesRegister"),
              meta: {
                roles: ["login", "corp"],
                step: 2,
              },
            },
          ],
        },
        {
          path: "acnPwdUptReqCorp",
          description: "계좌비밀번호 변경",
          redirect: { name: "acnPwdUptReqStep1Corp" },
          component: () => import("@/views/templates/admin/acnPwdUptReq"),
          children: [
            {
              path: "step1",
              name: "acnPwdUptReqStep1Corp",
              description: "목록",
              component: () => import("@/views/templates/admin/acnPwdUptReqStep1"),
              meta: {
                transparent: true,
                roles: ["login", "corp", "master"],
                step: 1,
              },
            },
            {
              path: "step2",
              name: "acnPwdUptReqStep2Corp",
              description: "등록",
              component: () => import("@/views/templates/admin/acnPwdUptReqStep2"),
              meta: {
                transparent: true,
                roles: ["login", "corp", "master"],
                step: 2,
              },
            },
            {
              path: "step3",
              name: "acnPwdUptReqStep3Corp",
              description: "완료",
              component: () => import("@/views/templates/admin/acnPwdUptReqStep3"),
              meta: {
                transparent: true,
                roles: ["login", "corp", "master"],
                isLast: true,
              },
            },
          ],
        },
        {
          path: "transferLimitParentCorp",
          name: "transferLimitParentCorp",
          description: "이체한도 조회/감액",
          redirect: { name: "transferLimitCorp" },
          component: () => import("@/views/templates/admin/transferLimitParent"),
          children: [
            {
              path: "transferLimitCorp",
              name: "transferLimitCorp",
              description: "이체한도 조회",
              component: () => import("@/views/templates/admin/transferLimit"),
              meta: {
                roles: ["login", "corp"],
                step: 1,
              },
            },
            {
              path: "transferLimitDecrementCorp",
              name: "transferLimitDecrementCorp",
              description: "이체한도 감액",
              component: () => import("@/views/templates/admin/transferLimitDecrement"),
              meta: {
                roles: ["login", "corp"],
                step: 2,
              },
            },
            {
              path: "transferLimitCompleteCorp",
              name: "transferLimitCompleteCorp",
              description: "이체한도 수정 완료",
              component: () => import("@/views/templates/admin/transferLimitComplete"),
              meta: {
                roles: ["login", "corp"],
                transparent: true,
                isLast: true,
              },
            },
          ],
        },
      ],
    },
  ],
};

export default admin;
